import usePageTitle from '@/hooks/use-page-title';
import {Link, Route, Routes} from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import { useCurrentUser } from '@/hooks/api/use-user';
import ParrainagesDetail from "@/pages/parrainages/parrainages-detail";

const Parrainages = () => {
    usePageTitle('Mes parrainages');
    const isEligible = useCurrentUser().eligible_parrainage;

    return (
        <div className="w-full">
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                <span className="text-foreground">Mes parrainages</span>
            </nav>
            <div className="space-y-2 sm:space-y-3 mt-4">
                <h1 className="text-xl sm:text-2xl font-bold">Mes parrainages</h1>
            </div>

            {isEligible
                ? <Routes><Route index element={<ParrainagesDetail />}/></Routes>
                : <p className="mt-12 text-muted-foreground">Vous n'êtes pas éligible à l'offre de parrainage.</p>
            }
        </div>
    );
};

export default Parrainages;
